/** 加载触发器 */
export const GetAutomationTriggers = '/v1/automatic/triggers';

/** 根据ID获取触发器 */
export const GetAutomationTrigger = '/v1/automatic/trigger';

/** 许可检查 */
export const GetAutomationLimit = '/v1/automatic/limit';
